module.exports = {
  companies: 'Şirketler',
  catalogs: 'Kataloglar',
  accounts: 'Hesaplar',
  printers: 'Yazıcılar',
  login: 'Oturum aç',
  logout: 'Çıkış Yap',
};



// WEBPACK FOOTER //
// ./src/lang/tr/header.js